import { STOREFRONT_LANGUAGE_CODES } from "./storefront-codes.generated";

export type StorefrontLanguageCode = (typeof STOREFRONT_LANGUAGE_CODES)[number];

const storefrontLanguageCodes: ReadonlySet<string> = new Set(
  STOREFRONT_LANGUAGE_CODES
);

function isStorefrontLanguageCode(
  value: string
): value is StorefrontLanguageCode {
  return storefrontLanguageCodes.has(value);
}

export type StorefrontLanguageCodeResult =
  | { ok: true; language: StorefrontLanguageCode }
  | { ok: false; error: "unknownLocale"; locale: string };

/**
 * Converts the locale that Shopify reports for a storefront page
 * (`window.Shopify.locale`, for example `en` or `pt-BR`) to the Storefront API
 * `LanguageCode` (`EN`, `PT_BR`). An unknown locale is an error result, never
 * a missing language, so a caller cannot silently drop the language.
 */
export function toStorefrontLanguageCode(
  locale: string
): StorefrontLanguageCodeResult {
  // Shopify locales use a hyphen (`pt-BR`); the enum uses an underscore.
  const candidate = locale.includes("_")
    ? ""
    : locale.toUpperCase().replace("-", "_");
  return isStorefrontLanguageCode(candidate)
    ? { ok: true, language: candidate }
    : { ok: false, error: "unknownLocale", locale };
}
